<template>
  <div v-show="!progress">
    <!-- ふきだし -->
    <v-container v-show="bubbleContent">
      <v-row>
        <v-col>
          <Bubble :content="bubbleContent" />
        </v-col>
      </v-row>
    </v-container>

    <!-- 支払方法選択 -->
    <v-container v-if="payTypeSelectEnabled">
      <v-row>
        <v-col class="pt-0">
          <v-radio-group v-model="payTypeSelected" class="ml-4" column>
            <v-radio v-show="onlinePayment.linepay" value="0">
              <template slot="label">
                <img class="ml-2" :src="iconLINEPay" />
              </template>
            </v-radio>
            <v-radio v-show="onlinePayment.paypay" value="1">
              <template slot="label">
                <img :src="iconPayPay" />
              </template>
            </v-radio>
            <v-radio
              v-show="onlinePayment.credit"
              label="クレジットカード"
              value="2"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row class="mt-8">
        <v-col align="center">
          <v-btn large dark tile color="#ff8a65" @click="next">
            お支払いへすすむ
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-container v-else>
      <v-row
        ><v-col align="center">
          <v-btn x-large text class="mt-4" @click="close">
            <span class="text-decoration-underline">トーク画面へもどる</span>
          </v-btn>
        </v-col></v-row
      >
    </v-container> -->

    <!-- sheet エラー(共通) -->
    <v-bottom-sheet v-model="showErrorCmnSheet" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                question=""
                :content="errorSheetCmnText"
                :border-content="false"
              />
            </v-col>
          </v-row>

          <!-- 下部固定 -->
          <div style="align: center; width: 100%">
            <!-- <v-btn x-large text @click="showErrorCmnSheet = !showErrorCmnSheet"
              ><span class="text-decoration-underline white--text"
                >カートへもどる</span
              ></v-btn
            > -->
            <v-btn x-large text @click="close">
              <span class="text-decoration-underline white--text"
                >トーク画面へもどる</span
              >
            </v-btn>
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet エラー(カート移動) -->
    <v-bottom-sheet v-model="showSheetCart" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble :content="errorSheetCartText" :border-content="false" />
            </v-col>
          </v-row>
          <div class="mt-8 mb-8">
            <QuickReply
              text="カートを表示する"
              class="ma-2"
              :click="onClickToCart"
            />
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";
import { closeWindow, getAccessToken } from "../util/liff_util";
import { MSG_TYPE } from "../components/error/errorConstants";
import Bubble from "./parts/Bubble";
import QuickReply from "./parts/QuickReply";

import { CHECK_TYPE, createCheckErrMsg } from "../util/order_util";

// エラーシート
const SHEET_ERR_CMN = 0;
const SHEET_ERR_CART = 1;

export default {
  components: {
    Bubble,
    QuickReply,
  },
  data: () => ({
    payTypeSelected: null,
    bubbleContent: "",
    payTypeSelectEnabled: false, //支払方法選択可能かどうか
    cartMenus: [], // 現在のカート内のメニュー
    // icon
    iconLINEPay:
      "https://storage.googleapis.com/avt-nobunaga-261b3.appspot.com/pay/thumbs/linepay_200x200.png",
    iconPayPay:
      "https://storage.googleapis.com/avt-nobunaga-261b3.appspot.com/pay/thumbs/paypay_200x200.png",
    //
    showErrorCmnSheet: false,
    errorSheetCmnText: "",
    showSheetCart: false,
    errorSheetCartText: "",
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "決済方法 選択";
    this.$store.state.cart = false;
  },
  async mounted() {
    await liff.ready; // LIFF 初期化待機
    this.showProgress();
    try {
      await this.init();
    } catch (error) {
      console.log(error);
      const msgType = MSG_TYPE.LOAD;
      this.$router.replace({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["local", "progress", "userId", "shopId"]),
    ...mapGetters("settings", ["onlinePayment"]),
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "checkBeforeInit"]),
    ...mapActions("rest", ["deleteCartMenusByMstChanged"]),
    init: async function () {
      const queryCartId = this.$route.query.cartId;
      const checkResult = await this.checkBeforeInit({ queryCartId });
      if (!checkResult.result) {
        // ふきだしなし
        this.payTypeSelectEnabled = false;

        // シート
        // 初期表示時のエラーはすべてシート表示
        const checkType = checkResult.type;
        const sheetType = this.getErrorSheetType(checkType);
        const msg = createCheckErrMsg(checkType);
        console.log(`checkType=${checkType}, sheetType=${sheetType}`, msg);
        this.showErrorSheet(sheetType, msg);
        return;
      }

      // すべてチェックOK
      this.bubbleContent = this.createBubbleOk();

      // 決済方法関係
      this.payTypeSelected = this.onlinePayment.defaultSelected;
      this.payTypeSelectEnabled = true;
    },
    createBubbleOk: function () {
      const text = "どの方法でお支払いしますか？";
      return `${text}`;
    },
    next: async function () {
      if (this.payTypeSelected == "0") {
        await this.selectLinePay();
      } else if (this.payTypeSelected == "1") {
        await this.selectPayPay();
      }
    },
    onClickToCart: async function () {
      // カート内アイテム削除
      await this.deleteCartMenusByMstChanged();

      // 画面遷移 (カート)
      this.$router.push({ name: "Cart" });
    },
    close: function () {
      // LIFF 閉じる
      closeWindow();
    },
    showErrorSheet: function (type, msg) {
      switch (type) {
        case SHEET_ERR_CMN:
        default:
          this.errorSheetCmnText = msg;
          this.showErrorCmnSheet = !this.showErrorCmnSheet;
          break;
        case SHEET_ERR_CART:
          this.errorSheetCartText = msg;
          this.showSheetCart = !this.showSheetCart;
          break;
      }
    },
    getErrorSheetType: function (checkType) {
      switch (checkType) {
        case CHECK_TYPE.MST_MENU_SOLDOUT:
        case CHECK_TYPE.MST_MENU_CHANGED:
        case CHECK_TYPE.MST_MENU_DELETED:
        case CHECK_TYPE.ORDER_AVAILABLE:
        case CHECK_TYPE.USER_VISIT_TIME:
          return SHEET_ERR_CART;
        default:
          return SHEET_ERR_CMN;
      }
    },
    //==============================
    //TODO pay 関係ロジック外だし
    //==============================
    selectLinePay: async function () {
      // liff token
      let liffAccessToken = getAccessToken();
      if (this.local) {
        liffAccessToken = "LIFF_ACCESS_TOKEN";
      }

      // 起動リンク取得
      this.showProgress();
      const paymentUrl = await this.getPaymentUrlForLinePay(liffAccessToken);
      console.log(`paymentUrl=${paymentUrl}`);
      this.hideProgress();

      // LINEPay 起動
      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        // ふきだし
        this.bubbleContent = this.createBubbleContentPayError();
      }
    },
    selectPayPay: async function () {
      // liff token
      let liffAccessToken = getAccessToken();
      if (this.local) {
        liffAccessToken = "LIFF_ACCESS_TOKEN";
      }

      // 起動リンク取得
      this.showProgress();
      const paymentUrl = await this.getPaymentUrlForPayPay(liffAccessToken);
      console.log(`paymentUrl=${paymentUrl}`);
      this.hideProgress();

      // PayPay 起動
      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        // ふきだし
        this.bubbleContent = this.createBubbleContentPayError();
      }
    },
    selectCreditCard: async function () {
      console.log("not implemented");
    },
    getPaymentUrlForLinePay: async function (liffAccessToken) {
      try {
        const urlBase = process.env.VUE_APP_URL_BASE_PAY;
        const payReqUrl = `${urlBase}/linepay/request`;
        console.log("payReqUrl", payReqUrl);
        const payload = {
          shopId: this.shopId,
          userId: this.userId,
          liffAccessToken,
        };
        const res = await this.axios.post(payReqUrl, payload, {
          timeout: 30000,
        });
        return res.data.info.paymentUrl.web;
      } catch (error) {
        console.log(error);
        return "";
      }
    },
    getPaymentUrlForPayPay: async function (liffAccessToken) {
      try {
        const urlBase = process.env.VUE_APP_URL_BASE_PAY;
        const payReqUrl = `${urlBase}/paypay/qr`;
        console.log("payReqUrl", payReqUrl);
        const payload = {
          shopId: this.shopId,
          userId: this.userId,
          liffAccessToken,
        };
        const res = await this.axios.post(payReqUrl, payload, {
          timeout: 30000,
        });
        return res.data.paymentUrl;
      } catch (error) {
        console.log(error);
        return "";
      }
    },
    createBubbleContentPayError: function () {
      return "大変申し訳ございませんが、再度「お支払へすすむ」を押してください。";
    },
    // createPayload: function() {
    //   const userId = this.$store.getters.userId;
    //   const selectedItems = this.createSelectedItems();
    //   return {
    //     userId: userId,
    //     orderItems: selectedItems.map((item) => {
    //       return {
    //         name: item.title,
    //         category: "pastries",
    //         quantity: 1,
    //         productId: item.id,
    //         unitPrice: {
    //           amount: item.price,
    //           currency: "JPY",
    //         },
    //       };
    //     }),
    //     amount: {
    //       amount: selectedItems.reduce((acc, item) => {
    //         acc += item.price;
    //         return acc;
    //       }, 0),
    //       currency: "JPY",
    //     },
    //   };
    // },
    // createSelectedItems: function() {
    //   return [
    //     {
    //       title: "黒糖なんとか",
    //       id: 111,
    //       price: 1,
    //       image:
    //         "https://storage.googleapis.com/avt-nobunaga-261b3.appspot.com/thumbs/kogashi_okinawa_milk_200x200.png",
    //     },
    //     {
    //       title: "イチゴ練乳",
    //       id: 222,
    //       price: 2,
    //       image:
    //         "https://storage.googleapis.com/avt-nobunaga-261b3.appspot.com/thumbs/strawberry_milk_200x200.png",
    //     },
    //   ];
    // },
  },
};
</script>
